module.exports = __webpack_public_path__ + "img/鲁健.611ea014.jpg";